{
    "aboutbanner.label": "{siloName} Spazi sono diversi",
    "account.admin_email_notifications": "Notifiche email per gli amministratori",
    "account.admin_language": "Lingua preferita",
    "account.admin_language_no_language": "Nessuna lingua",
    "account.admin_moderation_dash_settings": "Impostazioni della dashboard di moderazione",
    "account.email_notifications": "Notifiche email",
    "account.notification.email.moderationdecisions": "Decisioni di moderazione",
    "account.notification.email.replies": "Risposte",
    "account.title": "Account",
    "account.warnings_and_blocks": "Avvisi e blocchi",
    "account_delete.confirm_description": "La cancellazione del tuo profilo è irreversibile. L'eliminazione di tutti i dati e attività associate può richiedere fino a 72 ore.",
    "account_delete.confirm_heading": "Sei sicuro di voler eliminare i dati del tuo profilo?",
    "account_delete.description": "Se richiesto, la cronologia delle discussioni del tuo account e le tue partecipazioni saranno eliminate. Questa azione è irreversibile.",
    "account_delete.heading": "Cancella i miei dati",
    "account_request_data.heading": "Richiedi i miei dati",
    "account_request_data.instructions": "Manda un'e-mail a [privacy@newpublic.org](mailto:privacy@newpublic.org) per richiedere una copia dei tuoi dati associati a questo spazio di discussione. Potrebbe volerci fino a 30 giorni per elaborare la richiesta.",
    "account_revoke_permissions.confirm_heading": "Revocare i permessi di amministratore di {identifier}?",
    "account_revoke_permissions.confirm_text": "{identifier} non avrà più i permessi di amministratore.",
    "account_revoke_permissions.revoke_button": "Revoca permessi",
    "action.block": "Blocca",
    "action.cancel": "Annulla",
    "action.create_new_voting": "Crea un nuovo voto",
    "action.delete": "Elimina",
    "action.edit": "Modifica",
    "action.open_teaser_positioning": "Apri il posizionamento del teaser",
    "action.pinned": "In evidenza",
    "action.post": "Pubblica",
    "action.reply_to_user": "Rispondi a {userName}...",
    "action.report": "Segnala",
    "action.save": "Salva",
    "action.unblock": "Sblocca",
    "admin.category_analysis_heading": "Analisi",
    "admin.category_developer_tools_heading": "Strumenti per sviluppatori",
    "admin.category_editorial_heading": "Editoriale",
    "admin.category_moderation_heading": "Moderazione",
    "admin.category_owner_tools_heading": "Strumenti per proprietari",
    "admin.category_starred_heading": "In evidenza",
    "admin.window_title": "Dashboard admin",
    "admin_mod_link.admin_users_description": "Gestisci le autorizzazioni degli utenti amministratori.",
    "admin_mod_link.developer_tools_label": "Strumenti per Sviluppatori",
    "admin_mod_link.editorial_dashboard_description": "Gestisci spazi e altro ancora.",
    "admin_mod_link.editorial_dashboard_label": "Pannello editoriale",
    "admin_mod_link.moderation_dashboard_description": "Moderare le discussioni nel cruscotto ristrutturato.",
    "admin_mod_link.moderation_dashboard_label": "Dashboard di Moderazione",
    "admin_mod_link.ranking_eval_description": "Valuta diversi algoritmi di classificazione su conversazioni reali.",
    "admin_mod_link.ranking_eval_label": "Valutazione della Classificazione",
    "admin_mod_link.settings_description": "Gestisci formati e funzionalità organizzativi.",
    "admin_mod_link.settings_label": "Impostazioni",
    "admin_mod_link.storybook_description": "Visualizza i componenti PSI in Storybook.",
    "admin_mod_link.storybook_label": "Storybook",
    "admin_users.add_admins_button": "Aggiungi amministratori",
    "admin_users.add_new_admins_label": "Aggiungi nuovi amministratori",
    "admin_users.adding_admins_message": "Aggiunta amministratori...",
    "admin_users.emails_placeholder": "Email degli utenti da aggiungere",
    "admin_users.heading": "Utenti admin",
    "admin_users.loading_message": "Caricamento degli amministratori...",
    "admin_users.updating_roles_message": "Aggiornamento dei ruoli in corso...",
    "admins.actions.edit": "Modifica",
    "admins.actions.revoke": "Revoca permessi",
    "admins.actions.revoke-failed": "Impossibile revocare i permessi di amministratore di {userIdentity}",
    "admins.actions.revoked": "{userIdentity} non ha più i permessi di amministratore",
    "admins.all_admins": "Tutti",
    "admins.column_actions": "Azioni",
    "admins.column_name": "Nome",
    "admins.column_posts": "Post",
    "admins.column_roles": "Permessi interni",
    "admins.column_title": "Titolo",
    "admins.error": "Impossibile recuperare la tabella degli amministratori",
    "admins.tab_label": "Profili del personale",
    "admins.table.search": "Cerca...",
    "admins.title": "Profili del personale",
    "agree": "D’accordo",
    "ai-helper.bullet": "👉 {tipText}",
    "ai-helper.rephrase_message": "Considera di riformulare il tuo messaggio per raggiungere un pubblico più ampio e stimolare discussioni più significative.",
    "ai-helper.suggestions_title": "Suggerimenti",
    "ai-helper.tips_title": "Prova a seguire questi consigli:",
    "aitag.ai_moderated": "Moderato dall’IA",
    "appError.goHome": "Torna indietro",
    "appError.page_forbidden": "Il tuo account non può accedere a questa pagina.",
    "appError.page_not_found": "La pagina che stai cercando non esiste.",
    "appError.page_unauthorized": "Non hai il permesso di accedere a questa pagina.",
    "article.admin_only_error": "Devi effettuare l’accesso come amministratore per visualizzare questa schermata.",
    "article.login_button": "Accedi",
    "article.no_teaser_error": "Nessun teaser definito",
    "article.teaser_type_section": "Tipo di Teaser",
    "article.zdf_section": "ZDF",
    "article_teaser_position.max_positions": "Massimo di 2 posizioni consentite",
    "audience_input_template.description": "Raccogli domande, testimonianze e storie dagli utenti. Questo consente un maggiore coinvolgimento.",
    "audience_input_template.label": "Input del pubblico",
    "blocklist.add_term_button": "Aggiungi termine",
    "blocklist.add_terms": "Aggiungi termini - separa più termini con ;",
    "blocklist.delete_confirmation": "Questi termini devono davvero essere eliminati? Puoi aggiungerli di nuovo in seguito.",
    "blocklist.delete_terms": "Elimina Termini",
    "blocklist.description": "Gestisci i termini che dovrebbero essere segnalati automaticamente.",
    "blocklist.edit_term": "Modifica Termine",
    "blocklist.empty_list": "La lista nera è vuota.",
    "blocklist.help_alternative_spellings_description": "Puoi decidere se tenere conto delle grafie alternative. Le seguenti grafie, numeri e caratteri speciali sono anche presi in considerazione:",
    "blocklist.help_alternative_spellings_title": "Grafie alternative:",
    "blocklist.help_case_note": "Maiuscole e minuscole sono prese in considerazione",
    "blocklist.help_character_replacements": "A → a  | a → A | a → @ | a → 4 | i → 1 | e → 3 | o → 0 | s → $ | s → 5 | t → 7 | b → 8 | g → 9",
    "blocklist.help_intro": "La blocklist ti consente di definire termini che sono automaticamente impediti di essere pubblicati nei post della comunità. Puoi aggiungere termini a questa pre-moderazione da solo. Aggiungi alla lista tutti i termini che non dovrebbero essere pubblicati senza revisione umana.",
    "blocklist.help_singular_term_description": "Puoi decidere se considerare solo il termine singolare o anche i termini che contengono il termine inserito.",
    "blocklist.help_singular_term_example": "Esempio: “persona” (termine singolare) → “persone”. “persone” verrebbe preso in considerazione anche se la casella “termine singolare” non è attivata per “persona”. Questo vale anche per la stringa “personalità”, ad esempio.",
    "blocklist.help_singular_term_title": "Termine singolare:",
    "blocklist.include_alternative_spellings": "Includi varianti ortografiche",
    "blocklist.no_results": "Nessuna voce corrisponde alla tua ricerca.",
    "blocklist.only_singular_term": "Solo termine singolare",
    "blocklist.settings_for_term": "Impostazioni per il termine",
    "blocklist.single_term_added_success": "Il termine \"{singleTerm}\" è stato aggiunto",
    "blocklist.single_term_not_deleted": "Impossibile eliminare il termine della blocklist",
    "blocklist.singular_term_tag": "Termine singolare",
    "blocklist.term_adoption_description": "Scegli se usare i termini esattamente come inseriti oppure in forma estesa.",
    "blocklist.term_already_in_list": "Questo termine è già nella lista",
    "blocklist.term_required": "Deve essere inserito un termine",
    "blocklist.terms_added_success": "{termsCount} termini sono stati aggiunti con successo",
    "blocklist.terms_already_in_list": "Questo termine è già nella lista",
    "blocklist.terms_may_not_be_longer_than": "I termini non possono superare i 150 caratteri.",
    "blocklist.terms_not_added_duplicate": "Il termine della blocklist esiste già: {duplicateTerms}",
    "blocklist.terms_not_added_mixed": "Il termine della blocklist esiste già: {duplicateTerms}. Impossibile aggiungere il termine della blocklist, riprova: {refusedTerms}",
    "blocklist.terms_not_added_refused": "Impossibile aggiungere il termine della blocklist, riprova: {refusedTerms}",
    "blocklist.terms_not_deleted": "Impossibile eliminare {failedCount} termini della blocklist su {totalCount}",
    "blocklist.title": "Lista di blocco",
    "blocklist.too_long_terms_removed": "I termini più lunghi di 150 caratteri sono stati rimossi.",
    "button.react": "Reagisci",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "deselezionata",
    "button.react_button_selected": "Selezionato",
    "button.reacted": "Reagito",
    "byline.deleted_user": "Utente Eliminato",
    "byline.edited": "Modificato",
    "byline.post_id": "ID:",
    "channel_settings.title": "Impostazioni del canale",
    "channels.add_channel_button": "Aggiungi canale",
    "channels.channels_label": "Canali",
    "channels.default_channel_label": "Canale predefinito",
    "channels.delete_tooltip": "Non puoi eliminare il canale predefinito o i canali attualmente in uso",
    "channels.image_preview": "Anteprima immagine",
    "channels.manage_channels_heading": "Gestisci i canali",
    "channels.no_channel": "Nessun canale",
    "channels.no_channels_available": "Nessun canale disponibile",
    "channels.no_channels_available_info": "Crea e gestisci i canali nella dashboard di moderazione.",
    "channels.not_channel_member_warning": "Non sei un membro del canale, alcune funzioni sono disabilitate!",
    "channels.select_channel": "Seleziona un canale",
    "channels.title": "Canale",
    "close_conversation.closed_message": "Questa conversazione è ora chiusa.",
    "comment.cancel_button": "Annulla",
    "comment.confirm_leave_description": "Le modifiche apportate non verranno salvate.",
    "comment.confirm_leave_heading": "Sei sicuro di voler uscire?",
    "comment.delete_button": "Elimina",
    "comment.delete_modal_heading": "Sei sicuro di voler eliminare questo post?",
    "comment.delete_modal_warning": "Questa azione non può essere annullata.",
    "comment.edit_button": "Modifica",
    "comment.post_button": "Pubblica",
    "comment.posting": "Pubblicazione in corso...",
    "comment.public_comment_subtitle": "Commento pubblico",
    "comment.read_more_button": "Leggi di più",
    "comment.reply_button": "Rispondi",
    "comment.report_button": "Segnala",
    "comment.show_less": "Mostra meno",
    "comment.show_more_replies_plural": "Mostra {count} altre risposte",
    "comment.show_more_reply_singular": "Mostra {count} altra risposta",
    "comment.show_original": "Mostra originale ({language})",
    "comment.show_translation": "Mostra traduzione ({language})",
    "comment.update_button": "Aggiorna",
    "comment.updating": "Aggiornamento in corso...",
    "comment.your_reply_label": "La tua risposta",
    "comment_feedback.only_visible_to_you": "Visibile solo a te",
    "comment_slider.change_vote_button": "Aggiorna la tua risposta",
    "comment_slider.its_complicated": "È complicato",
    "comment_slider.no_with_reservations": "Piuttosto no",
    "comment_slider.public_response": "Risposta pubblica",
    "comment_slider.recording_vote": "Registrazione del voto...",
    "comment_slider.response": "risposta",
    "comment_slider.responses": "risposte",
    "comment_slider.share_thoughts": "Condividi i tuoi pensieri",
    "comment_slider.skip_change_vote": "Salta e cambia voto",
    "comment_slider.skip_submit_vote": "Salta e invia voto",
    "comment_slider.slide_to_respond": "Scorri per rispondere:",
    "comment_slider.strongly_no": "Decisamente no",
    "comment_slider.strongly_yes": "Decisamente sì",
    "comment_slider.update_response": "Aggiorna la tua risposta",
    "comment_slider.yes_with_reservations": "Piuttosto sì",
    "comment_slider_editable_positions.heading": "Personalizza il cursore dei commenti",
    "comment_slider_template.description": "Chiedi agli utenti di rispondere alla tua domanda lungo uno spettro (ad es. “Decisamente no” a “Decisamente sì”).",
    "comment_slider_template.label": "Cursore commento",
    "common.access_denied": "Accesso negato",
    "common.are": "sono",
    "common.cancel": "Annulla",
    "common.download": "Scarica",
    "common.is": "è",
    "common.loading": "Caricamento...",
    "common.select": "Seleziona",
    "community_guidelines.aria_popup_label": "{label} (finestra pop-up)",
    "community_guidelines.category_engage_respectfully": "Partecipa con rispetto",
    "community_guidelines.category_no_disruptive_behavior": "Nessun comportamento disturbante",
    "community_guidelines.category_no_harmful_content": "Nessun contenuto dannoso",
    "community_guidelines.category_support_claims": "Sostieni le tue affermazioni",
    "community_guidelines.modal_heading": "Linee guida e norme della comunità",
    "community_guidelines.modal_intro": "Ci impegniamo a ispirare conversazioni reali, rispettose e aperte in questo spazio. Tutti sono invitati a condividere le proprie esperienze; scambiare e dibattere prospettive; e fare domande nello spirito di gentilezza, connessione e curiosità.",
    "community_guidelines.moderation_process_explanation": "I moderatori esaminano tutto ciò che tu e gli altri pubblicate prima che appaia qui. Potrebbe volerci del tempo prima che il tuo post venga pubblicato. Ti preghiamo di avere pazienza. Ci assicuriamo che tutti seguano le nostre linee guida della comunità. Se ci sono minacce di un crimine, suicidio o attacco, informeremo la polizia.",
    "community_guidelines.no_meaningless_chars": "Nessuna parola priva di significato, sequenze di numeri o simili.",
    "community_guidelines.not_alone_heading": "Non sei solo!",
    "community_guidelines.not_published": "Se il tuo post viola le linee guida della comunità, i moderatori non lo pubblicheranno.",
    "community_guidelines.rule_avoid_derogatory_labels": "Evita etichette denigratorie",
    "community_guidelines.rule_avoid_sarcasm": "Evita sarcasmo e risposte sprezzanti",
    "community_guidelines.rule_explain_constructively": "Spiega i disaccordi in modo costruttivo",
    "community_guidelines.rule_express_civility": "Esprimi le tue idee con civiltà",
    "community_guidelines.rule_focus_on_ideas": "Concentrati sulle idee, piuttosto che sui giudizi sulla persona",
    "community_guidelines.rule_no_illegal_content": "Nessun contenuto illegale",
    "community_guidelines.rule_no_offtopic": "Niente messaggi fuori tema",
    "community_guidelines.rule_no_spam": "Niente spam o promozione commerciale",
    "community_guidelines.rule_no_violent_content": "Nessun contenuto violento o incitamento al danno",
    "community_guidelines.rule_provide_sources": "Fornisci fonti per le affermazioni di fatto",
    "community_guidelines.rule_respect_privacy": "Rispetta la privacy degli altri, non condividere informazioni personali",
    "community_guidelines.title": "Linee guida della comunità",
    "community_guidelines.what_happens_heading": "Cosa succede quando il tuo contributo viola le linee guida o le norme della comunità?",
    "context_entry_points.From": "Da",
    "context_entry_points.joined_from": "Unito da",
    "conversation_helper.about": "Informazioni su Conversation Helper",
    "conversation_helper.analyze_conversation": "Analizza la conversazione",
    "conversation_helper.checks_performed": "- **{count} controllo/i** effettuati",
    "conversation_helper.conversation_analysis": "Analisi della conversazione",
    "conversation_helper.conversation_stats": "Statistiche della conversazione",
    "conversation_helper.conversation_summary": "Riepilogo della conversazione",
    "conversation_helper.current_guidance": "Guida attuale",
    "conversation_helper.dashboard": "Pannello dell’assistente alla conversazione",
    "conversation_helper.disagree": "In disaccordo",
    "conversation_helper.explanation": "Spiegazione",
    "conversation_helper.generate_new_guidance": "Genera una nuova guida",
    "conversation_helper.generated_because": "Questo messaggio è stato generato perché...",
    "conversation_helper.generated_by_ai": "Questa guida è generata dall'IA.",
    "conversation_helper.guidance_messages_generated": "- **{count} messaggio/i guida generato/i",
    "conversation_helper.guidance_visible_to_everyone": "Questo messaggio guida è visibile a tutti.",
    "conversation_helper.hello_everyone": "Ciao a tutti!",
    "conversation_helper.help_history": "Cronologia dell’aiuto",
    "conversation_helper.helpful": "Utile",
    "conversation_helper.last_analysis_none": "- Ultima analisi della conversazione: **Nessuna**",
    "conversation_helper.last_analysis_time": "- Ultima analisi della conversazione: **{time}**",
    "conversation_helper.new_comments_since_analysis": "- **{count} nuovo/i commento/i** dall’ultima analisi",
    "conversation_helper.no_history": "Nessuna cronologia disponibile.",
    "conversation_helper.no_problems": "Nessun problema rilevato.",
    "conversation_helper.open_admin_dashboard": "Apri Dashboard Amministratore",
    "conversation_helper.problems_detected": "Problemi rilevati!",
    "conversation_helper.related_space": "Discussione correlata",
    "conversation_helper.result": "Risultato: ",
    "conversation_helper.thank_you": "Grazie",
    "conversationhelper.ai.hint": "Per mantenere un'atmosfera accogliente e rispettosa, utilizziamo anche l'IA per supportare la moderazione. In questa conversazione, un'IA fornisce suggerimenti per un'atmosfera di conversazione più costruttiva e riassume la conversazione.",
    "cta_button.loading": "Caricamento in corso",
    "dashboard.table.demo.pagination": "Spazi (Paginati)",
    "dashboard.table.demo.users": "Discussioni",
    "date.days_abbrev": "{days}g",
    "date.hours_abbrev": "{hours}h",
    "date.minutes_abbrev": "{minutes}m",
    "date.months_abbrev": "{months}m",
    "date.now": "adesso",
    "date.years_abbrev": "{years}a",
    "deleted_post.author_deleted": "L'autore ha eliminato questo post.",
    "deleted_post.deleting": "Eliminazione in corso…",
    "deleted_post.you_deleted": "Hai eliminato questo post.",
    "demo.comment": "commento",
    "demo.comments": "commenti",
    "demo.count_noun": "{count} {noun}",
    "demo.disagree": "In disaccordo",
    "demo.fwrd": "SUCCESSIVO",
    "demo.load_video_element": "Carica elemento video",
    "demo.new_to_me": "Nuovo per me",
    "demo.pause": "PAUSA",
    "demo.play": "RIPRODUCI",
    "demo.prev": "PRECEDENTE",
    "demo.respect": "Rispetto",
    "demo.thank_you": "Grazie",
    "demo.tile_admin_users_description": "Gestisci le autorizzazioni degli utenti amministratori.",
    "demo.tile_admin_users_label": "Utenti admin",
    "demo.tile_topics_label": "Argomenti",
    "developer_tools.email_testing": "Test email",
    "developer_tools.email_testing_description": "Invia un'email di prova al tuo indirizzo email dell'account.",
    "developer_tools.installed_versions": "Versioni installate",
    "developer_tools.key": "Chiave",
    "developer_tools.send_test_email": "Invia email di prova",
    "developer_tools.sending": "Invio...",
    "developer_tools.test_email_sent": "Email di prova inviata con successo tramite {provider}",
    "developer_tools.title": "Strumenti per sviluppatori",
    "developer_tools.translation_queue": "Translation Queue",
    "developer_tools.translation_queue_description": "Process pending translation jobs for the current silo.",
    "developer_tools.translation_queue_done": "Elaborazione della coda di traduzione completata",
    "developer_tools.translation_queue_locked": "La coda è bloccata — un altro processo è già in esecuzione.",
    "developer_tools.translation_queue_process": "Process Queue",
    "developer_tools.translation_queue_processing": "Processing...",
    "developer_tools.translation_queue_result": "Elaborati: {processed}, Falliti: {failed}, Saltati: {skipped}",
    "developer_tools.translation_queue_stats": "Attività in coda: {total} ({pending} in attesa, {failed} fallite)",
    "developer_tools.unable_to_display": "Impossibile visualizzare le variabili d'ambiente.",
    "developer_tools.value": "Valore",
    "developer_tools.version_client": "Client",
    "developer_tools.version_server": "Server",
    "developer_tools.version_unknown": "Sconosciuto",
    "dialogue.recording_vote": "Registrazione del voto...",
    "dialogue.response_count": "{total} risposte",
    "dialogue.response_plural": "{count} risposte",
    "dialogue.response_singular": "{count} risposta",
    "dialogue.share_your_thoughts": "Condividi i tuoi pensieri...",
    "dialogue.skip_submit_vote": "Salta e invia il voto",
    "dialogue.update_response": "Aggiorna la tua risposta",
    "dialogue_editable_labels.heading": "Personalizza dialogo",
    "dialogue_template.description": "Chiedi agli utenti di rispondere alla tua domanda con un semplice “sì” o “no”.",
    "dialogue_template.label": "Dialogo",
    "disagree": "In disaccordo",
    "editable_positions_widget.button_label": "Modifica posizioni",
    "editable_positions_widget.label": "Posizione #{position}",
    "editorial_dash.title": "Pannello editoriale",
    "editorial_experts.with-experts": "Con esperti editoriali",
    "editorial_question.be_first": "Sii il primo a condividere i tuoi pensieri",
    "editorial_question.count_noun": "{count} {noun}",
    "editorial_question.join_discussion": "Unisciti alla discussione",
    "editorial_question.lets_talk": "Parliamone...",
    "editorial_question.response_singular": "risposta",
    "editorial_question.responses_plural": "risposte",
    "editorial_question.share_thoughts": "Condividi i tuoi pensieri",
    "error.api": "Qualcosa è andato storto",
    "error.network": "Errore di rete - Controlla la tua connessione a Internet e riprova.",
    "features.srg_section": "SRG",
    "filter_list_popover.trigger_more_filters": "Altri filtri",
    "footer.made_by": "Creato da ",
    "form.accordion.hide_details": "Nascondi dettagli",
    "form.accordion.show_details": "Mostra dettagli",
    "form.add_button": "Aggiungi",
    "form.adding_button": "Aggiunta in corso...",
    "form.cancel_button": "Annulla",
    "form.create_space_button": "Crea spazio",
    "form.delete_button": "Elimina",
    "form.edit_button": "Modifica",
    "form.other": "Altro",
    "form.remove_button": "Rimuovi",
    "form.required_label": "{label} (obbligatorio)",
    "form.save_button": "Salva",
    "form.uncheck_all": "Deseleziona tutto",
    "form.update_button": "Aggiorna",
    "format.count_noun": "{count} {noun}",
    "invite_user.button": "Invita utente",
    "invite_user.error": "Impossibile invitare {email}. Per favore, riprova.",
    "invite_user.modal.email_label": "Indirizzo email",
    "invite_user.modal.heading": "Invita utente",
    "invite_user.modal.invite_button": "Invita",
    "invite_user.modal.subheading": "Invita qualcuno a diventare un [utente editoriale](https://newpublic.notion.site/Technical-support-2e7fbd65fb3e80e39f11f750d0f5b129) negli strumenti PSI.",
    "invite_user.success": "{email} è stato invitato.",
    "language.de-CH": "Tedesco (Svizzera)",
    "language.de-DE": "Tedesco",
    "language.en-US": "Inglese",
    "language.fr-BE": "Francese (Belgio)",
    "language.fr-CA": "Francese (Canada)",
    "language.fr-CH": "Francese (Svizzera)",
    "language.fr-FR": "Francese",
    "language.it-CH": "Italiano (Svizzera)",
    "language.it-IT": "Italiano",
    "language.nl-NL": "Olandese",
    "language.rm-CH": "Romancio (Svizzera)",
    "legal.privacy_notice": "Informativa sulla privacy",
    "legal.terms_of_service": "Termini di servizio",
    "linked_partner_story.incomplete_list_banner": "Questo elenco di storie potrebbe essere incompleto.",
    "linked_partner_story.linked_articles_description": "Visualizza le storie collegate a questa conversazione.",
    "linked_partner_story.linked_articles_heading": "Storie collegate",
    "linked_partner_story.no_articles_found": "Non ci sono ancora storie collegate a questo spazio.",
    "linked_partner_story.read_article_link": "Leggi l'articolo",
    "linked_partner_story.view_video_link": "Guarda il video",
    "list.selected_items_count": "{keyCount} elementi selezionati",
    "llm_ranking.best": "Migliore",
    "loading": "Caricamento...",
    "login.account_blocked_explanation": "Nessuna azione necessaria per la beta. Solo un moderatore può ripristinare l'accesso alla discussione.",
    "login.account_blocked_heading": "Non puoi accedere perché il tuo account è bloccato",
    "login.account_not_impacted": "Il tuo account {siloName} non è interessato ed è ancora accessibile.",
    "login.continue_with": "Continua con {providerName}",
    "login.continue_with_google": "Continua con Google",
    "login.cookie_notice": "🍪 Questo spazio di discussione utilizza solo cookie essenziali. Non utilizziamo cookie per scopi pubblicitari. [Scopri di più]({privacyNoticeLink}).",
    "login.default_admin_login_heading_label": "Benvenuto in {psiBrandName}",
    "login.default_admin_login_subheading_label": "Accedi con il tuo account Admin per iniziare",
    "login.default_login_heading_label": "Uno spazio per discussioni sane e prospettive varie",
    "login.dev_login": "Accesso Sviluppatore",
    "login.logging_in": "Accesso in corso...",
    "login.okay_button": "Va bene",
    "login.select_dev_persona": "Seleziona una persona sviluppatore",
    "login.sso_error": "Qualcosa è andato storto durante l'accesso. Chiudi questa finestra e riprova.",
    "main.checkbox.label": "Nuovi post \"in revisione\"",
    "modal.cancel_button": "Annulla",
    "modal.close_button": "Chiudi",
    "modal.confirm_leave_button": "Lascia",
    "modal.info_title": "Info",
    "moddashboard.cannot_reply": "Non puoi rispondere a questo post.",
    "moddashboard.cannot_reply_deleted": "Non puoi rispondere a un post eliminato.",
    "moddashboard.failed_to_post_reply": "Impossibile pubblicare la risposta",
    "moddashboard.publicly_reply_as": "Rispondi pubblicamente come",
    "moddashboard.reply_description": "La tua risposta viene pubblicata nello spazio della conversazione ed è visibile a tutti gli utenti.",
    "moddashboard.reply_posted_successfully": "La tua risposta è stata pubblicata con successo",
    "moddashboard.reply_to_user": "Rispondi a {userName}...",
    "moddashboard.your_reply": "La tua risposta",
    "moderate_dialog.locked_name": "{name} sta esaminando",
    "moderate_spaces.title": "Modera spazi",
    "moderation.add_explanation_to_user": "Aggiungi spiegazione all'utente",
    "moderation.admin_bypass_ai_and_manual_moderation": "Questo spazio ha la moderazione AI e umana abilitata, ma come utente Admin bypasserai automaticamente entrambe.",
    "moderation.admin_bypass_ai_moderation": "Questo spazio ha la moderazione AI abilitata, ma come utente Admin la bypasserai automaticamente.",
    "moderation.admin_bypass_flag": "Hai aggirato un flag dell'IA",
    "moderation.admin_bypass_manual_moderation": "Questo spazio ha la moderazione umana abilitata, ma come utente Admin la bypasserai automaticamente.",
    "moderation.admin_bypassed": "⚠️ L'IA ha segnalato la tua risposta, ma l'hai automaticamente aggirata come utente Admin.",
    "moderation.admin_filter_notice": "Per contribuire a migliorare la moderazione dell'IA, invia uno screenshot del tuo post e questo messaggio al tuo team.",
    "moderation.ai_and_manual_label": "Moderato da AI e manualmente",
    "moderation.ai_flag": "Segnalazione IA",
    "moderation.ai_mistake_explanation": "L’IA ci aiuta a moderare i commenti, ma a volte può sbagliare. Se l’IA ti impedisce di condividere un’opinione rispettosa, invia il tuo commento a un moderatore per una revisione.",
    "moderation.ai_wrong_question": "L’IA ha sbagliato?",
    "moderation.approved_tag": "Approvato",
    "moderation.automaticallyApproved": "Approvato automaticamente",
    "moderation.awaitingDecision": "In attesa di decisione",
    "moderation.blocked": "Bloccato",
    "moderation.bypassedPremoderation": "Premoderazione bypassata",
    "moderation.check_your_thing": "⚠️ Controlla il tuo {moderatedThing}",
    "moderation.dash.add_explanation_to_user": "Aggiungi spiegazione all'utente",
    "moderation.dash.approve": "Approva",
    "moderation.dash.approve_toast": "Approvato con successo",
    "moderation.dash.base_filter._rejected": "Rifiutato manualmente",
    "moderation.dash.base_filter.approved": "Approvato",
    "moderation.dash.base_filter.auto_approved": "Approvato automaticamente",
    "moderation.dash.base_filter.awaiting_decision": "In attesa di decisione",
    "moderation.dash.base_filter.bypassed_premod": "Premoderazione aggirata",
    "moderation.dash.base_filter.deleted_by_user": "Eliminato dall'utente",
    "moderation.dash.base_filter.manually_approved": "Approvato manualmente",
    "moderation.dash.base_filter.my_bookmarks": "I miei segnalibri",
    "moderation.dash.base_filter.warnings": "Avvisi",
    "moderation.dash.block": "Blocca",
    "moderation.dash.block_user": "Blocca l’utente",
    "moderation.dash.blocked": "Bloccato",
    "moderation.dash.blocking_info": "L'utente non potrà accedere allo spazio di discussione. Un utente deve essere avvisato 2 volte prima di poter essere bloccato.",
    "moderation.dash.cancel_rejection": "Annulla",
    "moderation.dash.explanation_to_user": "Spiegazione all'utente",
    "moderation.dash.feature_disabled": "Questa funzione è disabilitata.",
    "moderation.dash.finish_rejecting": "Termina il rifiuto",
    "moderation.dash.judgement_card.moderate": "Modera",
    "moderation.dash.operation_error": "Operazione non riuscita, per favore riprova",
    "moderation.dash.reject": "Rifiuta",
    "moderation.dash.reject_toast": "Rifiutato con successo",
    "moderation.dash.select_all_that_apply": "Seleziona tutte le opzioni che si applicano.",
    "moderation.dash.this_account_is_blocked": "🚫 Questo account è bloccato.",
    "moderation.dash.time": "volta",
    "moderation.dash.times": "volte",
    "moderation.dash.user_already_warned": "Questo utente è già stato avvisato {count} {noun}.",
    "moderation.dash.user_must_be_warned_2_times": "Un utente deve essere avvertito 2 volte prima di poter essere bloccato.",
    "moderation.dash.user_successfully_blocked": "{user} bloccato con successo",
    "moderation.dash.user_successfully_unblocked": "{user} è stato sbloccato con successo",
    "moderation.dash.user_successfully_warned": "{user} avvisato con successo",
    "moderation.dash.warn_or_block_user": "Avvisare o bloccare l'utente?",
    "moderation.dash.warn_user": "Avverti l'utente",
    "moderation.dash.warning_email_info": "L'utente riceverà una notifica via email che è stato avvisato. Puoi rimuovere l'avviso dall'account dell'utente in seguito.",
    "moderation.dash.what_guidelines_violated": "Quali linee guida viola questo commento?",
    "moderation.deletedByUser": "Eliminato dall'utente",
    "moderation.deletedUser": "Utente eliminato",
    "moderation.edit_your_post_button": "Modifica il tuo post",
    "moderation.explanations_sent_by_email": "Le spiegazioni sono inviate direttamente all'utente via e-mail dopo il tuo rifiuto.",
    "moderation.heated": "Acceso",
    "moderation.incompatible_warning": "La revisione AI ha trovato che il tuo {moderatedThing} potrebbe essere incompatibile con le seguenti [Linee guida della comunità]($onPress):",
    "moderation.infoBannerLoader.label": "Revisione della tua risposta...",
    "moderation.info_ai_and_manual_moderation_banner_text": "Per mantenere un ambiente accogliente e rispettoso, tutti i post in questo spazio sono moderati sia da AI che manualmente prima della pubblicazione per garantire che seguano le [Linee guida della comunità]($onPress)",
    "moderation.info_ai_moderation_banner_text": "Per mantenere un ambiente accogliente e rispettoso, questo spazio utilizza l'AI per aiutare a moderare i commenti. L'AI potrebbe segnalare il tuo post per una revisione aggiuntiva se non segue le [Linee guida della comunità]($onPress)",
    "moderation.info_manual_moderation_banner_text": "Per mantenere un ambiente accogliente e rispettoso, tutti i post in questo spazio sono moderati manualmente prima della pubblicazione per rispettare le [Linee guida della comunità]($onPress)",
    "moderation.liveThread": "Discussione in diretta",
    "moderation.manuallyApproved": "Approvato manualmente",
    "moderation.manuallyRejected": "Rifiutato manualmente",
    "moderation.message_to_moderator_placeholder": "Messaggio al moderatore...",
    "moderation.mode_ai": "Moderazione AI",
    "moderation.mode_ai_and_manual": "Moderazione AI e manuale",
    "moderation.mode_ai_post_anyway": "Moderazione AI con pubblicazione comunque",
    "moderation.mode_manual": "Moderazione manuale",
    "moderation.new": "Nuovo",
    "moderation.perspective_label": "etichetta di prospettiva",
    "moderation.popular": "Popolare",
    "moderation.post_without_editing_button": "Pubblica senza modificare",
    "moderation.postedAnyway": "Pubblicato comunque",
    "moderation.provide_details_help": "Fornisci eventuali dettagli per aiutarci a determinare se il tuo post rispetta le nostre linee guida.",
    "moderation.rejected_by_moderator": "Rifiutato dal moderatore",
    "moderation.reported_by_n_users": "Segnalato da {count} utenti",
    "moderation.response": "risposta",
    "moderation.select_all_that_apply": "Seleziona tutte quelle che si applicano.",
    "moderation.send_for_review_button": "Invia a un moderatore per la revisione",
    "moderation.send_to_moderator_button": "Invia al moderatore",
    "moderation.send_to_moderator_title": "Invia al moderatore",
    "moderation.sending": "Invio in corso...",
    "moderation.sent_for_review_message": "La tua risposta è stata inviata al moderatore per la revisione.",
    "moderation.sent_to_moderator": "La tua risposta è stata inviata al moderatore per la revisione.",
    "moderation.sent_to_moderator_time": "Inviato al moderatore: {time}",
    "moderation.share_details": "Condividi i dettagli",
    "moderation.singularTerm": "Termine singolare",
    "moderation.strict_filter_notice": "⚠️ Il nostro filtro di moderazione è attualmente impostato per essere piuttosto severo per garantire il massimo livello di sicurezza! Se ritieni che il tuo contributo sia stato ingiustamente rifiutato, contatta il nostro team di moderazione!",
    "moderation.system_unavailable_message": "Il nostro sistema di moderazione AI è temporaneamente non disponibile. Puoi comunque inviare il tuo post a un moderatore umano per la revisione.",
    "moderation.system_unavailable_title": "⚠️ Sistema di moderazione temporaneamente non disponibile",
    "moderation.take_second_look_rephrase": "📢 Considera di riformulare il tuo messaggio per raggiungere un pubblico più ampio e stimolare discussioni più significative.",
    "moderation.take_second_look_title": "Dai un'altra occhiata",
    "moderation.take_second_look_warning": "❗️ La nostra revisione AI suggerisce che la tua risposta potrebbe allontanare persone che non condividono il tuo punto di vista.",
    "moderation.thank_you": "Grazie!",
    "moderation.under_review": "In revisione",
    "moderation.update_without_editing_button": "Aggiorna senza modificare",
    "moderation.use_ai_title": "✨ Usiamo l'IA per la moderazione",
    "moderation.warned": "Avvisato",
    "moderation.what_guideline_violate": "Quali linee guida vengono violate da questo commento?",
    "moderation.write_additional_explanation": "Scrivi una spiegazione aggiuntiva per l'utente riguardo al tuo rifiuto.",
    "moderation.zdfComment": "Commento ZDF",
    "moderation_card.auto_translated": "Tradotto automaticamente",
    "moderation_card.language_tag": "{locale} | Tradotto",
    "moderation_card.origin": "Origine:",
    "moderation_card.origin_not_available": "Nessuna origine disponibile",
    "moderation_card.show_original": "Mostra originale ({locale})",
    "moderation_card.show_translation": "Mostra traduzione ({locale})",
    "moderation_dash.add_your_notes": "Aggiungi le tue note...",
    "moderation_dash.blocklist": "Lista di blocco",
    "moderation_dash.channel_settings": "Impostazioni del canale",
    "moderation_dash.community_guideline_violation": "⚠️ Violazione delle linee guida della community",
    "moderation_dash.count_users": "{count} utenti",
    "moderation_dash.created_by": "Creato da",
    "moderation_dash.explanation_to_user": "Spiegazione all'utente",
    "moderation_dash.internal_notes": "Note interne",
    "moderation_dash.manually_rejected": "Rifiutato manualmente",
    "moderation_dash.message_to_moderator": "Messaggio al moderatore",
    "moderation_dash.moderate_spaces": "Modera spazi",
    "moderation_dash.no_spaces": "Nessuno spazio ancora",
    "moderation_dash.num_stories": "{numArticles} storie",
    "moderation_dash.posts": "Post",
    "moderation_dash.posts.title": "Modera i post",
    "moderation_dash.premod_eval_tab": "Valutazione AI",
    "moderation_dash.queue.all_posts_hidden_plural": "{count} post sono nascosti dai filtri sopra.",
    "moderation_dash.queue.all_posts_hidden_singular": "1 post è nascosto dai filtri sopra.",
    "moderation_dash.queue.load_more": "Carica di più",
    "moderation_dash.queue.no_posts_yet": "Non ci sono ancora post.",
    "moderation_dash.rejected_by": "Rifiutato da",
    "moderation_dash.reported_by": "Segnalato da",
    "moderation_dash.selected_community_guideline_violation": "⚠️ Violazione delle linee guida della community selezionata",
    "moderation_dash.user_report": "Segnalazione utente",
    "moderation_queue.button_filters": "Filtri",
    "moderation_queue.clear_all": "Cancella tutto",
    "moderationdash.title": "Dashboard di Moderazione",
    "moderationdash.user_information": "Informazioni sull'utente",
    "moderationdash.user_metadata.comments_and_replies": "Post:",
    "moderationdash.user_metadata.flagged_comments": "Post segnalati dall'IA:",
    "moderationdash.user_metadata.rejected_comments": "Post rifiutati:",
    "moderationdash.user_metadata.reported_comments": "Post segnalati:",
    "moderationdash.user_metadata.user_warnings": "Avvertimenti:",
    "moderationtag.manually_moderated": "Moderato manualmente",
    "most_popular.most_popular_label": "Più popolari",
    "most_popular.most_recent_label": "Più recenti",
    "most_popular.show_more_button": "Mostra più risposte",
    "navigation_header.back_button": "Indietro",
    "neutral": "Neutro",
    "notification.dismiss_button": "Ignora",
    "notification.new_moderation_tasks": "Notifiche sui nuovi compiti di moderazione pronti per la revisione",
    "notification.new_moderation_tasks_settings": "Impostazioni per le notifiche sui nuovi compiti di moderazione pronti per la revisione",
    "notification.new_moderation_tasks_settings.checkboxMyChannels": "... nei miei canali",
    "notification.new_moderation_tasks_settings.checkboxSpacesICreated": "... negli spazi che ho creato",
    "notification.new_moderation_tasks_settings.checkboxSpacesIFollow": "... negli spazi che seguo",
    "onboarding.dismiss_button": "Ignora",
    "original_language": "Lingua originale",
    "pagination_row.next_page": "Pagina successiva",
    "pagination_row.previous_page": "Pagina precedente",
    "pagination_row.showing": "Mostrando {start}-{end} di {total}",
    "perspectives.add_new_perspective": "Aggiungi una nuova prospettiva",
    "perspectives.add_your_own": "Aggiungi la tua",
    "perspectives.add_your_perspective": "Aggiungi la tua prospettiva",
    "perspectives.dont_see_one": "Non ne vedi uno che si adatta?",
    "perspectives.enter_label_placeholder": "Inserisci un'etichetta di prospettiva",
    "perspectives.havent_heard_yet": "Non abbiamo ancora sentito queste prospettive",
    "perspectives.how_relate_question": "Qual è il tuo rapporto con questa questione?",
    "perspectives.poll_title": "Da chi abbiamo sentito",
    "perspectives.share_thoughts_button": "Condividi i tuoi pensieri",
    "perspectives.title": "Prospettive",
    "pin_comment.feature_label": "Metti in evidenza",
    "pin_comment.featured_label": "In evidenza",
    "pin_to_feed.move_down": "Sposta giù",
    "pin_to_feed.move_up": "Sposta su",
    "pin_to_feed.pin_label": "Fissa",
    "pin_to_feed.pinned_label": "Fissato",
    "poll.change_vote_button": "Modifica la mia risposta",
    "poll.result_vote": "{tLabel}: {percent}%",
    "poll.result_your_vote": "{tLabel} (tuo voto): {percent}%",
    "poll.submit_vote_button": "Invia il mio voto",
    "poll.write_in_topic": "Scrivi un argomento...",
    "poll.you": "Tu",
    "poll.you_comment": "Voi ({comment})",
    "poll_question.add_option_button": "Aggiungi opzione",
    "poll_question.option_placeholder": "Scrivi la tua opzione...",
    "poll_question.options_label": "Opzioni del sondaggio",
    "poll_question.question_label": "Domanda del sondaggio",
    "poll_question.question_placeholder": "Scrivi la tua domanda del sondaggio...",
    "poll_result.percent": "{percent}%",
    "popup.close_button": "Chiudi finestra",
    "popup_tip.more_information": "Maggiori informazioni",
    "post.post_anyway_button": "Pubblica comunque",
    "post.posting_anyway": "Pubblicazione comunque...",
    "post.submit": "Invia",
    "post.submitting": "Invio in corso...",
    "post.update": "Aggiorna",
    "post.update_anyway_button": "Aggiorna comunque",
    "post.updating": "Aggiornamento in corso...",
    "post.updating_anyway": "Aggiornamento comunque...",
    "premod_review.ai_eval_title": "Valutazione AI",
    "premod_review.ai_flag_label": "Bandiera AI",
    "premod_review.badge_ai_correct": "AI corretta",
    "premod_review.badge_ai_incorrect": "AI errata",
    "premod_review.badge_needs_evaluation": "Necessita di valutazione",
    "premod_review.badge_wrong_reason": "Motivo sbagliato",
    "premod_review.based_on_evaluations": "Basato su {count} valutazioni \"{verdict}\"",
    "premod_review.correct_rules_label": "Regole corrette",
    "premod_review.disabled": "La raccolta dati per la revisione pre-moderazione è stata disabilitata su questo server. Questa funzione è abilitata per impostazione predefinita. Per riabilitarla, rimuovere PREMOD_REVIEW_DISABLED=true da .env.",
    "premod_review.empty_state": "Non ci sono post da valutare in questa categoria.",
    "premod_review.evaluate_title": "Valuta la bandiera AI",
    "premod_review.evaluation_correct": "L'AI ha ragione - il post viola le linee guida",
    "premod_review.evaluation_incorrect": "L'AI ha torto - il post dovrebbe essere consentito",
    "premod_review.evaluation_set_tooltip": "Utilizziamo l'IA per generare un nuovo set di post sintetici che presentano gli stessi casi limite incontrati dai post reali mostrati qui nei dati di valutazione.",
    "premod_review.evaluation_submitted_toast": "La tua valutazione è stata inviata",
    "premod_review.evaluation_wrong_reason": "Corretto bloccare, ma per il motivo sbagliato",
    "premod_review.evaluator_explanation": "Spiegazione del valutatore",
    "premod_review.expiration_tooltip": "I commenti scadono dopo 30 giorni per conformarsi alla nostra politica sulla privacy.",
    "premod_review.expired": "Scaduto",
    "premod_review.expires_in": "Scade in {days}g",
    "premod_review.export_description": "Scarica un file con post realmente recensiti da questa categoria di valutazione.",
    "premod_review.export_heading": "Genera dati di valutazione per il download",
    "premod_review.file_format_label": "Formato del file",
    "premod_review.file_ready": "File {format} pronto!",
    "premod_review.filter_ai_correct": "AI corretta",
    "premod_review.filter_ai_incorrect": "AI errata",
    "premod_review.filter_needs_evaluation": "Necessita di valutazione",
    "premod_review.filter_wrong_reason": "Motivo sbagliato",
    "premod_review.format_csv": "CSV",
    "premod_review.format_json": "JSON",
    "premod_review.generate_data": "Genera dati",
    "premod_review.loading": "Caricamento in corso...",
    "premod_review.moderate_posts_description": "Fornisci feedback sulle decisioni dell'AI di segnalare i post per la moderazione. Questo lavoro costruisce dataset di valutazione per migliorare l'accuratezza della pre-moderazione dell'AI nel tempo.",
    "premod_review.post_label": "Post",
    "premod_review.reason_description": "Questo sarà utilizzato per generare dati di addestramento sintetici per migliorare l'AI.",
    "premod_review.reason_label": "Spiega la tua valutazione",
    "premod_review.reason_placeholder": "es., \"Questa è una critica legittima alla politica, non un attacco personale\"",
    "premod_review.regenerate_data": "Rigenera dati",
    "premod_review.select_format": "Seleziona il formato di esportazione",
    "premod_review.select_format_description": "Scegli un formato di file per l'esportazione dei tuoi dati.",
    "premod_review.space_label": "Spazio",
    "premod_review.submit": "Invia",
    "premod_review.submitting": "Invio in corso...",
    "premod_review.which_rules_violated_label": "Quali regole viola effettivamente questo post?",
    "premod_review.why_not_ai_rules_label": "Perché il post non viola le regole citate dall'IA?",
    "premod_review.why_not_ai_rules_placeholder": "Spiega perché le regole citate dall'IA non si applicano...",
    "premod_review.why_violates_label": "Perché il post viola queste regole?",
    "premod_review.why_violates_placeholder": "Spiega perché questo post viola le regole che hai selezionato...",
    "premod_review.your_evaluation": "La tua valutazione (obbligatoria)",
    "privacy.only_visible_to_you": "🔒 Visibile solo a te",
    "profile.add_custom_name": "Aggiungi un nome personalizzato",
    "profile.beta_feedback_note": "Partecipando alla nostra beta, potresti essere invitato a inviare feedback sulla tua esperienza con questo prodotto.",
    "profile.collaboration_note": "Questo spazio di discussione è ospitato da New_ Public, in collaborazione con {psmName}.",
    "profile.consent_aria": "Accetto le Linee guida della comunità, l'Informativa sulla privacy e i Termini di servizio.",
    "profile.consent_text": "Accetto le [Linee guida della comunità]({communityGuidelinesLink}), l'[Informativa sulla privacy]({privacyNoticeLink}) e i [Termini di servizio]({termsOfServiceLink}).",
    "profile.custom_photo_label": "Foto profilo personalizzata",
    "profile.edit.custom-title": "Aggiungi un titolo personalizzato",
    "profile.edit.custom_title": "Aggiungi un titolo personalizzato",
    "profile.edit.heading": "Modifica",
    "profile.edit.name": "Nome profilo",
    "profile.edit.name_override": "Nome",
    "profile.edit.name_override.placeholder": "Aggiungi il tuo nome alternativo...",
    "profile.edit.override_name_title": "Sostituisci il nome del profilo",
    "profile.edit.override_photo_title": "Sostituisci la foto del profilo",
    "profile.edit.photo": "Foto profilo",
    "profile.edit.photo_override": "URL foto",
    "profile.edit.photo_override.placeholder": "Aggiungi il tuo URL alternativo...",
    "profile.edit.title": "Titolo",
    "profile.edit.windows_title": "Modifica: {name}",
    "profile.edit_module_button": "Modifica {tLabel}",
    "profile.editorial_info": "Come utente Admin, puoi accedere a più opzioni per il tuo profilo nella [Dashboard Editoriale]({link}).",
    "profile.error_name_empty": "I nomi personalizzati non possono essere vuoti.",
    "profile.error_name_invalid": "I nomi personalizzati possono contenere solo lettere minuscole e numeri.",
    "profile.error_name_looks_real": "I nomi personalizzati non devono sembrare nomi reali.",
    "profile.error_name_taken": "Questo nome personalizzato è già in uso.",
    "profile.error_name_violates": "Questo nome personalizzato non è conforme alle nostre linee guida della comunità.",
    "profile.finish_button": "Fine",
    "profile.go_to.edit": "Modifica sostituzioni",
    "profile.helper_text": "Scegli un nome e una foto che appaiono quando pubblichi nella comunità.",
    "profile.is_titled_writer": "È un autore titolato",
    "profile.loading": "Caricamento profilo...",
    "profile.module_name": "nome",
    "profile.module_photo_and_name": "foto e nome",
    "profile.name_change_allowed_characters": "I nomi personalizzati possono includere solo lettere minuscole e numeri.",
    "profile.name_label": "Nome del profilo",
    "profile.no_user_error": "Utente inesistente",
    "profile.photo_label": "La tua foto del profilo",
    "profile.photo_url_aria": "URL della foto",
    "profile.photo_url_placeholder": "URL della foto",
    "profile.please_wait": "Attendere...",
    "profile.public_overriden": "Le tue informazioni sono state modificate da un amministratore",
    "profile.setup_title": "Imposta il tuo profilo",
    "profile.title_heading": "Titolo",
    "profile.title_placeholder": "Inserisci titolo",
    "profile.username_placeholder": "utente123",
    "profile.warn_overriden": "Le tue informazioni sono state modificate da un amministratore nel [Pannello Editoriale]({link}).",
    "profile_answers.admins_can_view": "Gli amministratori e i moderatori possono sempre visualizzare la tua cronologia.",
    "profile_answers.discussion_history": "Cronologia delle discussioni",
    "profile_answers.edit_visibility": "Modifica visibilità",
    "profile_answers.history_private": "La cronologia di questo utente è privata.",
    "profile_answers.load_more": "Carica di più",
    "profile_answers.rejected": "Il commento è stato rifiutato da un moderatore",
    "profile_answers.under_review": "Il commento è in fase di revisione",
    "profile_answers.visible_to_everyone": "Visibile a tutti",
    "profile_menu.dialog_label": "Menu del profilo",
    "profile_menu.menu_label": "Account",
    "prosocial_ranking.toggle_label": "Classifica prosociale",
    "puppet_test_support.login_user_a": "Accedi come Utente A",
    "puppet_test_support.login_user_b": "Accedi come Utente B",
    "puppet_test_support.login_user_c": "Accedi come Utente C",
    "puppet_test_support.reset_silo": "Reimposta silo di test",
    "puppet_test_support.secret_label": "Segreto Puppet",
    "puppet_test_support.title": "Strumenti di test Puppet",
    "question.actions.close_button": "Chiudi",
    "question.actions.close_confirm_button": "Chiudi",
    "question.actions.close_modal_description": "Quando chiuso, uno spazio diventa \"solo lettura\". La maggior parte delle azioni sono disabilitate e gli utenti non possono pubblicare, rispondere o reagire. Gli utenti possono ancora segnalare i commenti. Puoi riaprire la conversazione in qualsiasi momento.",
    "question.actions.close_modal_heading": "Chiudere questo spazio?",
    "question.actions.copy_button": "Copia",
    "question.actions.edit_button": "Modifica",
    "question.actions.link_copied_toast": "Link copiato negli appunti!",
    "question.actions.linked_stories_button": "Storie collegate",
    "question.actions.preview_button": "Anteprima",
    "question.actions.publish_button": "Pubblica",
    "question.actions.publish_confirm_button": "Pubblica",
    "question.actions.publish_modal_description": "Una volta pubblicato, questo spazio sarà visibile agli utenti sul tuo sito di produzione e sarà individuabile tramite SEO. Assicurati che il contenuto sia pronto per la visualizzazione pubblica. Puoi chiudere la conversazione in qualsiasi momento.",
    "question.actions.publish_modal_heading": "Pubblicare questo spazio?",
    "question.actions.publish_success_toast": "Spazio pubblicato",
    "question.actions.reopen_button": "Riapri",
    "question.actions.reopen_confirm_button": "Riapri",
    "question.actions.reopen_modal_description": "Riapri questo spazio per rendere la conversazione di nuovo attiva.",
    "question.actions.reopen_modal_heading": "Riaprire questo spazio?",
    "question.actions.tooltip": "Più opzioni",
    "question.actions.unpublish_button": "Annulla pubblicazione",
    "question.actions.unpublish_confirm_button": "Annulla pubblicazione",
    "question.actions.unpublish_modal_description": "Una volta non pubblicato, questo spazio non sarà più visibile agli utenti sul tuo sito di produzione e smetterà di essere indicizzato per SEO. Puoi ripubblicare la conversazione in qualsiasi momento.",
    "question.actions.unpublish_modal_heading": "Annullare la pubblicazione di questo spazio?",
    "question.actions.unpublish_success_toast": "Spazio non pubblicato",
    "question.add_content_label": "Aggiungi contenuto",
    "question.add_spaces_label": "Aggiungi spazi",
    "question.all_responses_tab": "Tutti i commenti",
    "question.conversation_format": "Formato della conversazione",
    "question.conversation_helper_section": "Assistente alla conversazione",
    "question.conversation_type_section": "Tipo di conversazione",
    "question.count_noun_format": "{count} {noun}",
    "question.edit_closed_banner": "Riapri questo spazio per modificarlo.",
    "question.edit_heading": "Modifica",
    "question.edit_page_title": "Modifica: {name}",
    "question.edit_thread_header_section": "Intestazione dello spazio",
    "question.error_empty_prompt": "Il prompt non può essere vuoto.",
    "question.error_prompt_too_long": "Il prompt deve contenere meno di {num} caratteri.",
    "question.general_section": "Generale",
    "question.input_placeholder": "Condividi i tuoi pensieri...",
    "question.moderation_approach": "Approccio alla moderazione",
    "question.moderation_label": "Moderazione",
    "question.moderation_mode": "Modalità di moderazione",
    "question.moderation_section": "Moderazione",
    "question.no_comments_message": "Sii il primo a condividere i tuoi pensieri",
    "question.no_comments_title": "Inizia la conversazione",
    "question.no_teaser_error": "Nessun teaser definito",
    "question.not_exist": "Questa domanda non esiste",
    "question.playbook_link": "Consulta il [manuale editoriale]({url}) per indicazioni.",
    "question.prompt_label": "Prompt",
    "question.prosocial_format_label": "Formato prosociale",
    "question.prosocial_ranking_section": "Classifica prosociale",
    "question.public_response_subtitle": "Risposta pubblica",
    "question.reaction_list_tooltip": "Vedi le reazioni",
    "question.reaction_plural": "reazioni",
    "question.reaction_singular": "reazione",
    "question.reply_placeholder": "Rispondi a {authorName}...",
    "question.reply_plural": "risposte",
    "question.reply_singular": "risposta",
    "question.select_format_placeholder": "Seleziona un formato",
    "question.select_moderation_placeholder": "Seleziona un'impostazione di moderazione",
    "question.upvote_plural": "voti positivi",
    "question.upvote_singular": "voto positivo",
    "question.your_response_title": "La tua risposta:",
    "ranking-eval.add_ranker": "Aggiungi Classificatore",
    "ranking-eval.back": "Indietro",
    "ranking-eval.builtin_rankers_desc": "Visualizza i prompt dei ranker integrati come riferimento per crearne di tuoi.",
    "ranking-eval.builtin_rankers_title": "Ranker Integrati",
    "ranking-eval.cancel": "Annulla",
    "ranking-eval.cancel_edit": "Annulla",
    "ranking-eval.comment_count": "{count} commenti",
    "ranking-eval.comment_scoring_desc": "Valuta ogni commento su una scala da 1 a 5 stelle",
    "ranking-eval.comments_random_order": "Commenti in ordine casuale",
    "ranking-eval.conversation_count": "{count} conversazioni",
    "ranking-eval.custom_rankers_desc": "Definisci classificatori personalizzati guidati da LLM per l'uso nella valutazione affiancata. I classificatori personalizzati appaiono nel menu a tendina del classificatore.",
    "ranking-eval.custom_rankers_title": "Classificatori Personalizzati",
    "ranking-eval.delete_ranker": "Elimina",
    "ranking-eval.disabled": "(disabilitato)",
    "ranking-eval.edit": "Modifica",
    "ranking-eval.edit_ranker": "Modifica Classificatore",
    "ranking-eval.filter.all_sources": "Tutte le Fonti",
    "ranking-eval.filter_all": "Tutti",
    "ranking-eval.filter_selected": "Selezionato",
    "ranking-eval.first_pass_placeholder": "Usa {{question}} e {{commentText}}",
    "ranking-eval.first_pass_prompt": "Prompt di Primo Passaggio",
    "ranking-eval.imported_at": "Recuperato {time}",
    "ranking-eval.importing": "Importazione conversazione...",
    "ranking-eval.loading_ranker": "Caricamento ranker...",
    "ranking-eval.model": "Modello",
    "ranking-eval.model_placeholder": "Seleziona modello",
    "ranking-eval.new_ranker": "Nuovo Classificatore",
    "ranking-eval.next_button": "Successivo →",
    "ranking-eval.no_cached": "Nessuna conversazione ancora memorizzata nella cache. Premi \"Aggiorna dalle fonti\" per recuperare le conversazioni dai siti partner.",
    "ranking-eval.no_comments": "Questa conversazione non ha commenti.",
    "ranking-eval.no_conversations_match": "Nessuna conversazione corrisponde.",
    "ranking-eval.no_custom_rankers": "Nessun classificatore personalizzato ancora. Clicca su \"Aggiungi Classificatore\" per crearne uno.",
    "ranking-eval.no_other_ratings": "Nessuna altra valutazione ancora.",
    "ranking-eval.no_ratings_yet": "Nessuna valutazione ancora.",
    "ranking-eval.no_spaces": "Nessuno spazio ancora. Aggiungine uno sopra per iniziare.",
    "ranking-eval.others_ratings": "Valutazioni degli altri",
    "ranking-eval.pick_conversation": "Scegli conversazione",
    "ranking-eval.prev_button": "← Precedente",
    "ranking-eval.ranker_col.actions": "Azioni",
    "ranking-eval.ranker_col.model": "Modello",
    "ranking-eval.ranker_col.name": "Nome",
    "ranking-eval.ranker_col.thinking": "Pensiero",
    "ranking-eval.ranker_col.topn": "Primi N",
    "ranking-eval.ranker_desc_placeholder": "Breve descrizione",
    "ranking-eval.ranker_description": "Descrizione",
    "ranking-eval.ranker_enabled": "Abilitato",
    "ranking-eval.ranker_name": "Nome",
    "ranking-eval.ranker_name_placeholder": "es. Dibattito Costruttivo",
    "ranking-eval.ranking_scoring": "Valutazione dei commenti... {scored} di {total}",
    "ranking-eval.ranking_selecting_top_10": "Selezione dei primi 10... potrebbe richiedere un po' di tempo",
    "ranking-eval.ranking_starting": "Avvio della classifica...",
    "ranking-eval.rating_reason_placeholder": "Perché questa valutazione?",
    "ranking-eval.reasoning": "Livello di Pensiero",
    "ranking-eval.reasoning_placeholder": "Seleziona livello",
    "ranking-eval.refresh": "Aggiorna dalle fonti",
    "ranking-eval.refresh_comments": "Aggiorna commenti",
    "ranking-eval.refresh_comments_in_progress": "Aggiornamento commenti in corso...",
    "ranking-eval.refresh_in_progress": "Aggiornamento in corso...",
    "ranking-eval.refreshing": "Recupero delle conversazioni dai siti partner...",
    "ranking-eval.save_ranker": "Salva",
    "ranking-eval.scoring_legend_title": "Guida alla valutazione",
    "ranking-eval.search_conversations": "Cerca conversazioni...",
    "ranking-eval.second_pass_placeholder": "Usa {{question}} e {{comments}}",
    "ranking-eval.second_pass_prompt": "Prompt di Secondo Passaggio",
    "ranking-eval.select_conversation": "Seleziona conversazione",
    "ranking-eval.select_ranker": "Seleziona classificatore",
    "ranking-eval.side_by_side_desc": "Confronta due algoritmi di classificazione fianco a fianco",
    "ranking-eval.spaces.column_actions": "Azioni",
    "ranking-eval.spaces.column_comments": "Commenti",
    "ranking-eval.spaces.column_created": "Creato",
    "ranking-eval.spaces.column_name": "Nome",
    "ranking-eval.spaces.score_comments": "Commenti sul punteggio",
    "ranking-eval.spaces.side_by_side": "Fianco a Fianco",
    "ranking-eval.spaces.title": "Spazi",
    "ranking-eval.submit_rating": "Invia valutazione",
    "ranking-eval.tab.comment_scoring": "Valutazione dei Commenti",
    "ranking-eval.tab.conversation_set": "Set di Conversazioni",
    "ranking-eval.tab.custom_rankers": "Classificatori Personalizzati",
    "ranking-eval.tab.side_by_side": "Affiancato",
    "ranking-eval.title": "Valutazione della Classificazione",
    "ranking-eval.top_n": "Primi N",
    "ranking-eval.top_n_placeholder": "20",
    "ranking-eval.top_ten_reasoning": "I 10 migliori motivi:",
    "ranking-eval.update_rating": "Aggiorna valutazione",
    "ranking-eval.view": "Visualizza",
    "ranking-eval.vote_a_best": "{ranker} è il migliore",
    "ranking-eval.vote_b_best": "{ranker} è il migliore",
    "ranking-eval.vote_tie": "Uguale",
    "ranking_debug.recompute": "Ricalcola la classifica",
    "ranking_debug.recomputing": "Ricalcolo della classifica…",
    "ranking_debug.toggle": "Mostra informazioni di debug della classifica",
    "ranking_debug.top_ten_reasoning": "Ragionamento dei primi 10:",
    "ranking_eval.show_debug_info": "Mostra informazioni di debug",
    "rating.its_complicated": "È complicato",
    "rating.no_with_reservations": "Piuttosto no",
    "rating.strongly_no": "Decisamente no",
    "rating.strongly_yes": "Decisamente sì",
    "rating.yes_with_reservations": "Piuttosto sì",
    "reaction_types.appreciation_plural": "apprezzamenti",
    "reaction_types.appreciation_singular": "apprezzamento",
    "reaction_types.constructive": "Costruttivo",
    "reaction_types.controversial": "Controverso",
    "reaction_types.count_noun": "{count} {noun}",
    "reaction_types.default_set": "Set predefinito",
    "reaction_types.empathetic": "Empatico",
    "reaction_types.enjoyable": "Piacevole",
    "reaction_types.fun_space": "Spazio divertente",
    "reaction_types.funny": "Divertente",
    "reaction_types.helpful": "Utile",
    "reaction_types.insightful": "Perspicace",
    "reaction_types.interesting": "Interessante",
    "reaction_types.nuanced": "Sfumato",
    "reaction_types.personal_space": "Spazio personale",
    "reaction_types.playful": "Giocoso",
    "reaction_types.reaction_set_label": "Set di reazioni",
    "reaction_types.relatable": "Mi ci ritrovo",
    "reaction_types.serious_space": "Spazio serio",
    "reaction_types.surprising": "Sorprendente",
    "reaction_types.why_appreciate": "Perché apprezzi questo post?",
    "related_content.add_content_button": "Aggiungi contenuto",
    "related_content.article_option": "Articolo",
    "related_content.audio_option": "Audio",
    "related_content.invalid_url_error": "Formato URL non valido. Inserisci un URL valido.",
    "related_content.label": "Contenuto correlato",
    "related_content.learn_more": "Scopri di più su questo argomento",
    "related_content.retrieve_article_error": "Impossibile recuperare le informazioni dell'articolo. Controlla l'URL e riprova.",
    "related_content.show_more_button": "Mostra di più",
    "related_content.story_format_label": "Formato della storia",
    "related_content.story_url_label": "URL della storia",
    "related_content.url_placeholder": "https://www.example.com",
    "related_content.video_option": "Video",
    "related_conversations.add_hint": "Aggiungi fino a un massimo di quattro spazi.",
    "related_conversations.add_spaces_button": "Aggiungi spazi",
    "related_conversations.limit_reached_error": "Questo spazio ha già quattro spazi correlati selezionati. Rimuovine uno prima di aggiungerne un altro.",
    "related_conversations.next_button": "Successivo",
    "related_conversations.no_spaces_available": "Nessuno spazio disponibile",
    "related_conversations.no_spaces_found": "Nessuno spazio trovato",
    "related_conversations.participant_count": "{count} {noun}",
    "related_conversations.participant_plural": "partecipanti",
    "related_conversations.participant_singular": "partecipante",
    "related_conversations.previous_button": "Precedente",
    "related_conversations.search_placeholder": "Cerca",
    "related_conversations.title": "Conversazioni correlate",
    "representing_perspectives_template.description": "Chiedi agli utenti di un insieme specifico di prospettive di rispondere alla tua domanda.",
    "representing_perspectives_template.description_1": "Scegli **3-5 prospettive specifiche** da cui vuoi sentire (es. «🏖️ Pensionato», «📦 Nuovo residente», «🍼 Genitore che lavora», ecc.)",
    "representing_perspectives_template.description_2": "Evita prospettive basate sulla demografia (es. «urbano», «basso reddito», «donna», ecc.) che potrebbero portare a stereotipi",
    "representing_perspectives_template.description_3": "Evita di attribuire convinzioni alle prospettive (es. «persona con un atteggiamento conservatore», o «sostenitori» e «oppositori»)",
    "representing_perspectives_template.description_4": "Scegli un'emoji per ogni prospettiva",
    "representing_perspectives_template.description_5": "Separa le prospettive con un'interruzione di riga.",
    "representing_perspectives_template.form_field_label": "Prospettive",
    "representing_perspectives_template.helper_label": "Definisci le tue prospettive",
    "representing_perspectives_template.label": "Rappresentare le Prospettive",
    "representing_perspectives_template.placeholder": "Scrivi 3-5 prospettive...",
    "roles.analyst": "Analista",
    "roles.developer": "Sviluppatore",
    "roles.editorial": "Redazione",
    "roles.moderator": "Moderatore",
    "roles.owner": "Proprietario",
    "roles.super_moderator": "Super Moderatore",
    "roles.unknown": "Sconosciuto",
    "satisfaction_survey_popover.question": "Quanto sei soddisfatto di questa piattaforma di discussione?",
    "satisfaction_survey_popover.satisfied_label": "Molto soddisfatto",
    "satisfaction_survey_popover.unsatisfied_label": "Molto insoddisfatto",
    "saving": "Salvataggio in corso...",
    "search.no_members_found": "Nessun membro trovato",
    "search.placeholder": "Cerca...",
    "settings.add_feature_button": "Aggiungi funzionalità",
    "settings.add_format_button": "Aggiungi formato",
    "settings.add_to_organization_button": "Aggiungi all'organizzazione",
    "settings.added_button": "Aggiunto",
    "settings.added_format_button": "Aggiunto",
    "settings.additional_features_heading": "Funzionalità Aggiuntive",
    "settings.ai_and_manual_moderation_description": "Richiedi che tutti i post inviati dagli utenti superino sia la revisione AI che quella umana prima della pubblicazione.",
    "settings.ai_pre_moderation_description": "Utilizza l'AI per garantire che i post inviati dagli utenti rispettino le Linee guida della comunità prima della pubblicazione.",
    "settings.ai_pre_moderation_with_post_anyway_description": "Consenti agli utenti di pubblicare post che l'AI classifica come di bassa qualità ma non dannosi, e classificali più in basso nel feed.",
    "settings.audience_input_description": "Raccogli domande, testimonianze e storie dagli utenti. Questo consente un maggiore coinvolgimento.",
    "settings.audience_input_label": "Input del Pubblico",
    "settings.blocklist_description": "Blocca parole specifiche da tutti i post inviati dagli utenti.",
    "settings.blocklist_label": "Lista di blocco",
    "settings.channels_description": "Organizza gli spazi in canali distinti, per permettere ai team editoriali e di moderazione di concentrarsi sui contenuti rilevanti.",
    "settings.channels_label": "Canali",
    "settings.comment_slider_description": "Chiedi agli utenti di rispondere alla tua domanda lungo uno spettro (es. “Decisamente no” a “Decisamente sì”).",
    "settings.comment_slider_label": "Cursore commento",
    "settings.dialogue_description": "Chiedi agli utenti di rispondere alla tua domanda con una semplice risposta “sì” o “no”.",
    "settings.dialogue_label": "Dialogo",
    "settings.heading": "Impostazioni {psiBrandName}",
    "settings.labs_description": "Formati prosociali nelle prime fasi di sviluppo, disponibili per la sperimentazione. Le funzionalità dei Labs sono completamente funzionali, ma mancano di impostazioni predefinite standardizzate e possono cambiare nel tempo.",
    "settings.labs_heading": "Labs",
    "settings.manual_moderation_description": "Richiedi che tutti i post inviati dagli utenti superino la revisione umana prima della pubblicazione; non utilizza l'AI per la moderazione.",
    "settings.moderation_heading": "Moderazione",
    "settings.premod_review_tab_description": "Aggiungi una scheda nella dashboard di moderazione in cui i moderatori esaminano ogni decisione presa dall'IA e registrano se è stata corretta.",
    "settings.premod_review_tab_label": "Scheda di valutazione dell'IA",
    "settings.prosocial_formats_description": "Ogni spazio di discussione è strutturato da un formato guidato prosociale.",
    "settings.prosocial_formats_heading": "Formati Prosociali",
    "settings.prosocial_ranking_description": "Mostra automaticamente in cima al feed i commenti più approfonditi e costruttivi.",
    "settings.prosocial_ranking_label": "Classifica prosociale",
    "settings.representing_perspectives_description": "Chiedi agli utenti di un insieme specifico di prospettive di rispondere alla tua domanda.",
    "settings.representing_perspectives_label": "Rappresentare le Prospettive",
    "settings.stories_description": "Collega gli URL delle storie pubblicate agli spazi di conversazione, in modo che una conversazione incorporata venga caricata nelle pagine che scegli. Richiede una configurazione aggiuntiva da parte degli sviluppatori.",
    "settings.stories_label": "Storie",
    "settings.titled_writers_description": "Identifica utenti selezionati come membri verificati della tua organizzazione quando scrivono commenti o rispondono ad altri.",
    "settings.titled_writers_label": "Scrittori Titolati",
    "settings.video_voting_description": "Sovrapponi domande su contenuti video.",
    "settings.video_voting_label": "Votazione video",
    "simple_ranking.most_reactions": "Più reazioni",
    "simple_ranking.newest": "Più recenti",
    "single_response_help.same_question_title": "Stessa domanda, nuovo articolo?",
    "single_response_help.update_response_label": "Aggiorna la tua risposta precedente con nuove prospettive",
    "slider_with_stop_points.aria_label": "Usa le frecce sinistra e destra oppure su e giù per regolare il cursore",
    "sort.all": "Tutti",
    "sort.ascending": "A-Z",
    "sort.descending": "Z-A",
    "sort.most_recent": "Più recenti",
    "sort.top": "Top",
    "sort.top_voted": "Più votati",
    "sort_button.aria_label": "Ordina per {text}",
    "sort_menu.sort_by_header": "Ordina per",
    "sorting.most_recent": "Più recenti",
    "sorting.oldest": "Più vecchio",
    "space.detail.id": "ID:",
    "space.detail.linkes.stories": "Storie collegate:",
    "space.detail.posts": "Post:",
    "space.table.demo.name": "Nome",
    "space.table.demo.responses": "risposte",
    "space.table.search": "Cerca...",
    "spaces.column_actions": "Azioni",
    "spaces.column_comments": "Commenti",
    "spaces.column_created": "Creato",
    "spaces.column_creationDate": "Creato",
    "spaces.column_format": "Formato",
    "spaces.column_name": "Nome",
    "spaces.column_needs_review": "Richiede revisione",
    "spaces.column_notification_follow": "Segui",
    "spaces.column_notification_following": "Seguiti",
    "spaces.column_notifications": "Notifiche",
    "spaces.column_responses": "risposte",
    "spaces.column_status": "Stato",
    "spaces.draft_created": "Spazio bozza creato",
    "spaces.draft_not_created": "Errore: spazio bozza non creato",
    "spaces.filter_active": "Attivo",
    "spaces.filter_closed": "Chiuso",
    "spaces.filter_draft": "Bozza",
    "spaces.filter_heated": "Riscaldato",
    "spaces.filter_needs_review": "Richiede revisione",
    "spaces.format_required_label": "Formato prosociale (richiesto)",
    "spaces.kickstart_conversation_tip": "Avvia questa conversazione aggiungendo almeno tre commenti.",
    "spaces.new_button": "Nuovo spazio",
    "spaces.new_space_title": "Nuovo spazio",
    "spaces.no_spaces_found": "Nessuno spazio trovato",
    "spaces.no_spaces_yet": "Nessuno spazio ancora",
    "spaces.no_templates_message": "Nessun modello disponibile",
    "spaces.prompt_help_avoid": "Evita:",
    "spaces.prompt_help_avoid_1": "Domande tendenziose",
    "spaces.prompt_help_avoid_2": "Argomenti puramente teorici",
    "spaces.prompt_help_good_prompts": "Buoni suggerimenti sono:",
    "spaces.prompt_help_tip_1": "Tempestivi, specifici, culturalmente rilevanti",
    "spaces.prompt_help_tip_2": "Aperti al dibattito e alla discussione",
    "spaces.prompt_help_tip_3": "Chiari e aperti, ma non astratti",
    "spaces.prompt_help_title": "Hai bisogno di aiuto per scrivere?",
    "spaces.prompt_label": "Prompt",
    "spaces.prompt_placeholder": "Scrivi una domanda o un prompt di discussione...",
    "spaces.status_active": "Attivo",
    "spaces.status_closed": "Chiuso",
    "spaces.status_draft": "Bozza",
    "spaces.still_need_help": "Ancora bisogno di aiuto?",
    "spaces.tab_label": "Discussioni",
    "spaces.title": "Discussioni",
    "spaces.visit_playbook": "Visita il PSI Playbook",
    "srg.profile.error_name_invalid": "I nomi personalizzati possono contenere solo lettere, numeri, spazi e trattini.",
    "standalone_question.participant": "partecipante",
    "standalone_question.participants": "partecipanti",
    "status.creation_successful": "Creazione riuscita",
    "status.edit_successful": "Modifica riuscita",
    "status.reload_to_see_effect": "Ricarica l'articolo per vedere l'effetto",
    "status.reported": "Segnalato",
    "story_dash.action_attach_spaces": "Collega spazi",
    "story_dash.action_edit_spaces": "Modifica gli spazi collegati",
    "story_dash.action_remove": "Rimuovi",
    "story_dash.action_view": "Visualizza storia",
    "story_dash.actions_column": "Azioni",
    "story_dash.add_story_button": "Aggiungi storia",
    "story_dash.add_title": "Aggiungi storia",
    "story_dash.attach_space_label": "Spazi",
    "story_dash.attach_space_modal_heading": "Collega spazi",
    "story_dash.attach_spaces": "Allega spazi",
    "story_dash.attach_spaces_button": "Allega spazi",
    "story_dash.attach_spaces_description": "Collega uno o più spazi esistenti a questa storia.",
    "story_dash.attach_spaces_modal_description": "Collega gli spazi esistenti a questa storia.",
    "story_dash.attached_spaces_more": "+{count} di più",
    "story_dash.cancel_button": "Annulla",
    "story_dash.connected_space_column": "Spazi collegati",
    "story_dash.create_button": "Aggiungi storia",
    "story_dash.date_column": "Pubblicato",
    "story_dash.domains_column": "Domini",
    "story_dash.filter_all": "Tutti",
    "story_dash.invalid_url_error": "Per favore inserisci un URL valido",
    "story_dash.name_column": "Nome",
    "story_dash.no_matches": "Nessuna storia corrisponde alla tua ricerca.",
    "story_dash.no_stories": "Nessuna storia ancora. Aggiungi una storia per iniziare.",
    "story_dash.remove_confirm_button": "Rimuovi",
    "story_dash.remove_modal_description": "Questa azione non può essere annullata. Qualsiasi spazio collegato verrà scollegato.",
    "story_dash.remove_modal_description_2": "Puoi aggiungere nuovamente la storia in qualsiasi momento e collegarla a uno spazio.",
    "story_dash.remove_modal_heading": "Rimuovere questa storia?",
    "story_dash.save_button": "Salva",
    "story_dash.search": "Cerca...",
    "story_dash.search_placeholder": "Cerca...",
    "story_dash.spaces_updated_toast": "Spazi aggiornati",
    "story_dash.story_added_toast": "Storia aggiunta",
    "story_dash.story_removed_toast": "Storia rimossa e spazio(i) scollegato(i)",
    "story_dash.story_url_label": "URL della storia",
    "story_dash.tab": "Storie",
    "story_dash.table_heading": "Storie",
    "story_dash.url_description": "Aggiungi un articolo, video o altro media.",
    "story_dash.url_placeholder": "www.esempio.com",
    "strongly_agree": "Totalmente d’accordo",
    "strongly_disagree": "Totalmente in disaccordo",
    "survey.feedback_help": "Il tuo feedback ci aiuterà a migliorare la tua esperienza.",
    "survey.strongly_agree": "Totalmente d’accordo",
    "survey.strongly_disagree": "Totalmente in disaccordo",
    "survey.tell_us_experience": "Raccontaci la tua esperienza",
    "survey.thank_you": "Grazie per aver condiviso la tua esperienza con noi!",
    "suspension.block_user_confirm": "Bloccare {userName}?",
    "suspension.block_user_description": "L'utente non sarà in grado di accedere allo spazio di discussione.",
    "suspension.moderator_blocked_you": "Un moderatore ti ha bloccato",
    "suspension.moderator_unblocked_you": "Un moderatore ti ha sbloccato",
    "suspension.moderator_unwarned_you": "Un moderatore ha rimosso l'avviso",
    "suspension.moderator_warned_you": "Un moderatore ti ha avvisato",
    "suspension.unblock_user_confirm": "Sbloccare {userName}?",
    "suspension.unblock_user_description": "L'utente potrà partecipare nuovamente allo spazio di discussione.",
    "table_grid.empty": "Ancora niente qui",
    "tag.beta": "Beta",
    "template.perspectives_description": "Separa le prospettive con un'interruzione di riga.",
    "template.perspectives_label": "Prospettive",
    "text.character_count": "{count}/{max} caratteri",
    "text.character_count_max": "{count}/{max} caratteri massimo",
    "text.character_count_min": "minimo {min} caratteri",
    "text.character_count_over_max": "{count}/{max} caratteri massimo",
    "text.character_count_progress_min": "{count}/{min} caratteri minimo",
    "tile.experimental_label": "Beta",
    "tile.outdated_label": "Obsoleto",
    "time.format": "{time}",
    "upvote.aria_label": "Voto positivo",
    "upvote.count": "{count}",
    "usability_survey.easy_to_use_question": "Questa piattaforma di discussione è facile da usare",
    "usability_survey.meets_needs_question": "Questa piattaforma soddisfa le mie esigenze",
    "user.member": "Membro",
    "user_info.account_button": "Account",
    "user_info.admin": "Amministratore",
    "user_info.developer_features": "Funzionalità per sviluppatori",
    "user_info.faqs": "FAQ",
    "user_info.log_in_button": "Accedi",
    "user_info.log_out_button": "Esci",
    "user_info.profile_button": "Profilo",
    "user_info.profile_menu_aria_label": "Menu del profilo per {name}",
    "video_link.go_to_video": "Vai al video",
    "video_voting.community_average": "Media della comunità",
    "video_voting.continue_button": "Continua",
    "video_voting.create_new_voting": "Crea un nuovo voto",
    "video_voting.current_session_state": "Oggetto stato sessione corrente",
    "video_voting.deactivate_all": " puoi disattivare questa funzione per tutti i video.",
    "video_voting.discourse": "Discorso",
    "video_voting.edit_title": "Modifica Voto Video",
    "video_voting.enable_all_videos": "Attiva il voto per tutti i video",
    "video_voting.enable_voting": "Abilita il voto",
    "video_voting.intro_text": "Questo video contiene domande del pubblico a cui puoi partecipare. Puoi votare in modo anonimo, saltare singole domande o disattivare questa funzione. Nelle ",
    "video_voting.join_discussion": "Unisciti alla discussione",
    "video_voting.manage_voting_admin": "Gestisci i voti (Admin)",
    "video_voting.no_data_available": "Nessun dato di voto disponibile",
    "video_voting.no_main_screen": "Nessuna schermata principale di voto video definita.",
    "video_voting.no_question_overlay": "Nessuna sovrapposizione di domande mostrata",
    "video_voting.no_space_selected": "Seleziona uno spazio per questa votazione prima di salvare.",
    "video_voting.not_logged_in_text": "Devi effettuare il login per usare questa funzione.\nIl video verrà riprodotto normalmente e non vedrai le votazioni.\n**Clicca qui per accedere**.",
    "video_voting.preview_admin": "Anteprima Video Voting (Admin)",
    "video_voting.select_voting_for_article": "Seleziona un voto per questo articolo",
    "video_voting.settings": "preferenze",
    "video_voting.start_video": "Avvia il video",
    "video_voting.template_missing": "Il modello di voto video è mancante",
    "video_voting.time": "Tempo:",
    "video_voting.title": "Votazione video",
    "video_voting.vote_anonymously": "Vota in modo anonimo",
    "video_voting.votings_tab": "Voti",
    "video_voting.waiting_for_video": "In attesa che il video si carichi!",
    "video_voting.you": "Tu",
    "videoplayer_demo.pause": "PAUSA",
    "videoplayer_demo.play": "RIPRODUCI",
    "videoplayer_demo.seek_60": "CERCA A 60 SECONDI",
    "videovoting.select_chapter": "Seleziona un capitolo",
    "videovoting.select_existing_voting": "Seleziona un Video Voting esistente",
    "videovoting.select_question": "Seleziona una domanda",
    "visibility.only_visible_to_admins": "Visibile solo agli Admin",
    "vote.delete_button": "Elimina",
    "vote.delete_modal_heading": "Sei sicuro di voler eliminare il tuo voto?",
    "vote.delete_modal_warning": "Questa azione non può essere annullata.",
    "voting.no": "No",
    "voting.yes": "Sì",
    "zdf_admin.votings": "Voti",
    "zdf_article.manage_teaser_positions": "Gestisci le posizioni dei teaser",
    "zdf_article.pick_positions": "Scegli fino a 2 posizioni",
    "zdf_article.teaser_position_last_paragraph": "Dopo l'ultimo paragrafo nel testo principale",
    "zdf_article.teaser_position_second_paragraph": "Dopo il secondo paragrafo nel testo principale",
    "zdf_article.teaser_position_second_subheading": "Sopra il secondo sottotitolo nel testo principale",
    "zdf_channels.add_channel_title": "Aggiungi Canale",
    "zdf_channels.add_members": "Aggiungi membri",
    "zdf_channels.channel_name_label": "Nome del Canale",
    "zdf_channels.default_channel_access": "Tutti gli utenti amministratori hanno accesso al canale predefinito.",
    "zdf_channels.default_channel_explanation": "Tutti gli utenti amministratori hanno accesso al canale predefinito.\n\nLe nuove domande che non sono assegnate a un canale specifico saranno assegnate al canale predefinito.\n\nPuò esserci solo un canale predefinito.",
    "zdf_channels.delete_channel_title": "Elimina Canale",
    "zdf_channels.delete_confirmation": "Vuoi davvero eliminare questo canale?",
    "zdf_channels.edit_channel_title": "Modifica Canale",
    "zdf_channels.image_url_label": "URL dell'immagine",
    "zdf_channels.member_search_field": "Campo di ricerca membri",
    "zdf_channels.members_label": "Membri",
    "zdf_channels.super_moderator_access": "Tutti i Super-Moderatori hanno accesso a questo canale.",
    "zdf_channels.use_as_default": "Usa come canale predefinito",
    "zdf_moddashboard.ai_explanation": "Spiegazione AI",
    "zdf_videovoting.no_session": "**Nessuna sessione avviata**",
    "zdf_videovoting.poll_type": "Sondaggio",
    "zdf_videovoting.slider_type": "Cursore",
    "zdf_videovoting_editor.add_chapter": "Aggiungi capitolo",
    "zdf_videovoting_editor.add_option": "Aggiungi opzione",
    "zdf_videovoting_editor.add_predetermined_answer": "Aggiungi una risposta predeterminata",
    "zdf_videovoting_editor.add_question": "Aggiungi domanda",
    "zdf_videovoting_editor.answer_label": "Etichetta della risposta",
    "zdf_videovoting_editor.answer_value": "Valore della risposta",
    "zdf_videovoting_editor.assign_chapter": "Assegna un capitolo",
    "zdf_videovoting_editor.assign_space": "Assegna uno spazio",
    "zdf_videovoting_editor.chapters": "Capitoli:",
    "zdf_videovoting_editor.layout": "Layout:",
    "zdf_videovoting_editor.maximum_value": "Valore massimo",
    "zdf_videovoting_editor.minimum_value": "Valore minimo",
    "zdf_videovoting_editor.name": "Nome",
    "zdf_videovoting_editor.open_preview": "Apri anteprima (debug)",
    "zdf_videovoting_editor.options": "Opzioni",
    "zdf_videovoting_editor.prefill_data": "Precompila dati da votazione esistente",
    "zdf_videovoting_editor.question_name": "Nome della domanda",
    "zdf_videovoting_editor.question_type": "Tipo di domanda",
    "zdf_videovoting_editor.questions": "Domande:",
    "zdf_videovoting_editor.remove_chapter": "Rimuovi capitolo",
    "zdf_videovoting_editor.selected_chapter": "Capitolo selezionato:",
    "zdf_videovoting_editor.selected_space": "Spazio selezionato:",
    "zdf_videovoting_editor.slider_answers": "Risposte del cursore",
    "zdf_videovoting_editor.slider_options": "Opzioni del cursore",
    "zdf_videovoting_editor.stops_video": "Ferma video",
    "zdf_videovoting_editor.timestamp": "Timestamp",
    "zdf_videovoting_editor.unit": "Unità",
    "zdf_videovoting_editor.video_info": "Informazioni sul video:",
    "zdf_videovoting_editor.voting_title": "Titolo della votazione",
    "{count} {noun}": "{count} {noun}"
}
